import { gql } from '@apollo/client';

const ORDER_FIELDS = `
  id
  userId
  status
  total
  billingName
  billingEmail
  billingPhone
  createdAt
  updatedAt
  paymentIntentId
  paymentMethodId
  stripeCustomerId
  rejectionReason
  approvedAt
  rejectedAt
  paidAt
  failedAt
  failureReason
  notes
  property {
    id
    name
  }
  reservation {
    id
    streamline_reservation_id
    check_in
    check_out
    guest_name
    email
    mobile_phone
  }
  items {
    id
    productId
    variationId
    title
    quantity
    price
    jobId
    product {
      id
      serviceTypeId
    }
    variation {
      id
      name
      price
    }
    job {
      id
      status
      isCompleted
      scheduledDate
      assignedTo {
        id
        name
      }
    }
  }
`;

// Query to get all orders (admin/property manager only)
export const GET_ALL_ORDERS = gql`
  query FindAllOrders {
    findAll {
      ${ORDER_FIELDS}
    }
  }
`;

// Query to get pending orders (admin/property manager only)
export const GET_PENDING_ORDERS = gql`
  query FindPendingOrders {
    findPendingOrders {
      ${ORDER_FIELDS}
    }
  }
`;

// Query to get a specific order by ID
export const GET_ORDER = gql`
  query FindOrder($id: String!) {
    findOne(id: $id) {
      id
      userId
      status
      total
      billingName
      billingEmail
      billingPhone
      billingAddressLine1
      billingAddressLine2
      billingCity
      billingState
      billingPostalCode
      billingCountry
      paymentIntentId
      paymentMethodId
      stripeCustomerId
      paymentMethodDetails
      notes
      createdAt
      updatedAt
      approvedById
      rejectedById
      approvedAt
      rejectedAt
      paidAt
      failedAt
      failureReason
      rejectionReason
      items {
        id
        productId
        variationId
        title
        quantity
        price
        createdAt
        updatedAt
      }
    }
  }
`;

// Query to get current user's orders
export const GET_MY_ORDERS = gql`
  query FindMyOrders {
    findMyOrders {
      id
      status
      total
      createdAt
      updatedAt
      items {
        id
        title
        quantity
        price
      }
    }
  }
`;

// Mutation to approve an order
export const APPROVE_ORDER = gql`
  mutation ApproveOrder($id: String!) {
    approveOrder(id: $id) {
      id
      status
      approvedAt
      approvedById
    }
  }
`;

// Mutation to reject an order
export const REJECT_ORDER = gql`
  mutation RejectOrder($id: String!, $reason: String) {
    rejectOrder(id: $id, reason: $reason) {
      id
      status
      rejectedAt
      rejectedById
      rejectionReason
    }
  }
`;

// Mutation to sync order payment status
export const SYNC_ORDER_PAYMENT_STATUS = gql`
  mutation SyncOrderPaymentStatus($id: String!) {
    syncOrderPaymentStatus(id: $id) {
      id
      status
      paymentIntentId
      paidAt
      failedAt
      failureReason
    }
  }
`;

export const CREATE_ORDER = gql`
  mutation CreateOrder($createOrderInput: CreateOrderInput!) {
    createOrder(createOrderInput: $createOrderInput) {
      id
      status
      total
      paymentIntentId
      billingName
      createdAt
    }
  }
`;

export const LINK_JOB_TO_ORDER_ITEM = gql`
  mutation LinkJobToOrderItem($orderItemId: ID!, $jobId: ID!) {
    linkJobToOrderItem(orderItemId: $orderItemId, jobId: $jobId) {
      id
      jobId
      job {
        id
        status
        isCompleted
      }
    }
  }
`;

export const GET_ORDERS_HISTORY = gql`
  query OrdersHistory($input: OrdersFilterInput) {
    ordersHistory(input: $input) {
      items {
        ${ORDER_FIELDS}
      }
      total
      page
      limit
      totalPages
      hasMore
    }
  }
`;

export const GET_PRODUCTS_LIST = gql`
  query GetProductsList {
    products {
      id
      title
    }
  }
`; 